<template>
  <v-row class="grey lighten-3" style="height: 1080px">
    <v-col md="4" class="hidden-sm-and-down side-image" style="background-color: #ffffff; font-size: 32px;">
      <a href="/" class="ml-4"><img src="../../assets/logo_text_black.svg" height="90" width="150"></a>
    </v-col>
    <v-col md="8" sm=12 style="background-color: #FFFFFF; position: relative;">
      <v-row justify="center" align-content="center" class="mt-10">
        <v-card-title class="font-weight-black">
          <p>パスワードを再設定しました！</p>
        </v-card-title>
      </v-row>
      <v-row justify="center" align-content="center" class="mt-10">
        <v-btn
            to="/login"
            color="primary"
            class="button-shadow ma-4"
            width="30%"
        >ログイン画面へ</v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'PasswordResetSuccess',
  data() {
    return {
      height: window.innerHeight,
    }
  }
}
</script>